module.exports = function() {
  return new Worker(__webpack_public_path__ + "6c74c9ab09ddbec1b3f8.worker.js");
};